import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// react-router v5 doesn't scroll to hash anchors, and page content is fetched
// client-side — so the target element usually isn't in the DOM yet when the
// route changes. Scroll as soon as it appears.
const ScrollToHash = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const id = decodeURIComponent(hash.slice(1));

    const scrollToTarget = () => {
      const el = document.getElementById(id);
      if (!el) return false;
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      return true;
    };

    // Element already rendered.
    if (scrollToTarget()) return;

    // Otherwise wait for the client-side content to render it in.
    const observer = new MutationObserver(() => {
      if (scrollToTarget()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Give up after a while so we don't observe forever.
    const timeout = setTimeout(() => observer.disconnect(), 10000);

    return () => {
      observer.disconnect();
      clearTimeout(timeout);
    };
  }, [pathname, hash]);

  return null;
};

export default ScrollToHash;
